import React, { useEffect, useState } from "react";
import { EVENT_TYPES, GAMES_MODES } from "../../../../../../../Config/helpers/constants";
import {
  Form,
  Input,
  Select,
  Steps,
  Row,
  Button,
  Col,
  Switch,
  TimePicker,
  Space,
  DatePicker
  // Table
} from "antd";
const { Option } = Select;
import moment from "moment";
import { Info } from "../../../../../../../common/Alerts/Message";
import { InputNumber } from "antd";

function MultiPlayerScheduleFields({
  state,
  nameOfRound,
  setNameOfRound,
  noOfKoGroups,
  setNoOfKoGroups,
  noOfTeamsFromEGroups,
  setNoOfTeamsFromEGroups,
  valbtime,
  minteams,
  setminteams,
  maxteams,
  setmaxteams,
  noofMatches,
  setnoofMatches,
  wantParrallelMatches,
  setwantParrallelMatches,
  timeforonematch,
  setTimeforonematch,
  onSelect,
  valstartingtime,
  setdob,
  dob,
  valtime,
  istrankpoints,
  setistrankpoints,
  lastrankpoints,
  setlastrankpoints,
  killpoints,
  setkillpoints,
  individualRankPoints,
  setIndividualRankPoints,
  playingTime,
  breakTime,
  parralelMatches
}) {
  // states
  const [currentStep, setCurrentStep] = useState(0);
  const [addManually, setAddManually] = useState(false);
  // logics and matches data
  // no of register teams without wildCards
  const noOfRegisteredTeams = state?.registerteams?.filter((team) => !team?.wildCard)?.length;
  const condition = state?.typeofmatch === GAMES_MODES.multi;
  const condition3 = noOfRegisteredTeams / noOfKoGroups;

  const averageNoOfTeamsInGroup =
    noOfKoGroups > 1 ? Math.floor(noOfRegisteredTeams / noOfKoGroups) : noOfRegisteredTeams;
  const teamsingroupscouldbe =
    parseInt(state?.registerteams?.length / (noOfKoGroups || 1)) + 3 || 1;

  let message = "max playing time could be (" + timeforonematch + ")";
  let messageb = "Both Match and break time should not exceed Playing Time";

  // handle changes, controllers
  const handleChange = (value, variable) => {
    if (value === undefined) return;
    if (variable === "group") {
      if (noOfKoGroups === 0) {
        return setNoOfKoGroups(1);
      } else {
        setNoOfTeamsFromEGroups();
        return setNoOfKoGroups(value);
      }
    } else {
      if (noOfTeamsFromEGroups === 0) {
        return setNoOfTeamsFromEGroups(1);
      } else {
        return setNoOfTeamsFromEGroups(value);
      }
    }
  };

  const handleChangeStep = (key) => {
    if (key === "next") {
      setCurrentStep((prev) => prev + 1);
    } else {
      setCurrentStep((prev) => prev - 1);
    }
  };

  useEffect(() => {
    if (addManually)
      setIndividualRankPoints(
        Array.from({ length: maxteams }, (_, index) => ({
          rank: index + 1,
          points: 0
        }))
      );
    else setIndividualRankPoints([]);
  }, [maxteams, minteams, addManually]);

  const handlePointsChange = (value, rank) => {
    setIndividualRankPoints((prev) =>
      prev.map((item) => (item.rank === rank ? { ...item, points: value } : item))
    );
  };

  const isScrimMode = () => {
    return state?.type === EVENT_TYPES.SCRIM;
  };

  return (
    <>
      {
        <Steps
          current={currentStep}
          items={[
            {
              title: "Group details"
            },
            {
              title: "Match Timing"
            },
            {
              title: "Score and wild cards"
            }
          ]}
        />
      }

      <main className="mt-5 mb-5 p-5">
        {/* step 0: one group details*/}
        {currentStep === 0 && (
          <Row justify="space-between">
            <Col>
              {condition ? (
                <Form.Item required className="halfwidth profileItems">
                  <label className="boldlabel">Name of Round</label>
                  <Input
                    maxLength={15}
                    value={nameOfRound}
                    onChange={(e) => setNameOfRound(e.target.value)}
                  />
                  <label className="boldlabel">
                    {state?.typeofmatch === GAMES_MODES.multi
                      ? "No. of Groups"
                      : "No. of Groups for Group Stages"}
                  </label>

                  <Select
                    value={isScrimMode() ? 1 : noOfKoGroups || 1}
                    placeholder=" 1,2,3,4...."
                    style={{ minWidth: "200px", maxWidth: "200px" }}
                    allowClear
                    disabled={isScrimMode()}
                    onChange={(e) => handleChange(e, "group")}
                    onClear={() => {
                      setNoOfKoGroups();
                    }}
                    options={Array.from({ length: noOfRegisteredTeams / 2 }, (_, i) => {
                      const condition = i > 0;
                      return condition ? { label: i, value: i } : null;
                    }).filter((e) => e)}
                  />
                  <label className="mb-2 boldlabel">
                    Total no of Teams in current round: {noOfRegisteredTeams}
                  </label>
                  <label className="mb-2 boldlabel">
                    Average no of Teams in each group: {averageNoOfTeamsInGroup}
                  </label>
                </Form.Item>
              ) : null}
              {/* max min teams */}
              {!isScrimMode() && (
                <>
                  <label className="boldlabel" style={{ fontSize: "17px" }}>
                    Minimum and Maximum teams in groups
                  </label>
                  <Form
                    style={{
                      gap: "8%",
                      marginTop: "30px",
                      position: "relative",
                      display: "flex"
                    }}
                    name="basic"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    autoComplete="off">
                    <Form.Item
                      style={{ position: "absolute", width: "100%", bottom: "0px" }}
                      help={valbtime === "error" ? messageb : null}
                      hasFeedback
                      required
                      validateStatus={valbtime}
                    />
                    <Form.Item className="profileItems">
                      <label className="boldlabel">Maximum</label>
                      <Select
                        className="ceinputfieldnos selectSmaller"
                        title="Maximumteams"
                        bordered={true}
                        value={maxteams}
                        onSelect={(e) => {
                          setmaxteams(e);
                          // if maxteams are less than min teams then set min teams to maxteams -1
                          if (e < minteams) {
                            const val = e - 1;
                            if (val < 1) {
                              setminteams(1);
                            } else {
                              setminteams(val);
                            }
                          }
                        }}>
                        {Array(teamsingroupscouldbe)
                          .fill(null)
                          .map((_, i) => (
                            <Option value={i + 1} key={`Maximumteams${i}`}>
                              {i + 1}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item className="profileItems">
                      <label className="boldlabel">Minimum</label>
                      <Select
                        className="ceinputfieldnos selectSmaller"
                        title="minimumteams"
                        bordered={true}
                        value={minteams}
                        onSelect={(e) => {
                          setminteams(e);
                        }}>
                        {Array(maxteams)
                          .fill(null)
                          .map((_, i) => (
                            <Option value={i + 1} key={`minimumteams${i}`}>
                              {i + 1}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Form>
                </>
              )}
            </Col>

            <Col>
              {" "}
              {/* no of teams moving */}
              {!isScrimMode() && condition ? (
                <Form.Item required className="halfwidth profileItems">
                  <label className="boldlabel">No. of teams moving from each group</label>
                  <Select
                    value={noOfTeamsFromEGroups}
                    placeholder={"1,2,3,4,...."}
                    style={{ minWidth: "200px", maxWidth: "200px" }}
                    allowClear
                    onChange={handleChange}
                    onClear={() => {
                      setNoOfTeamsFromEGroups();
                    }}
                    options={Array.from({ length: condition3 }, (_, i) => {
                      return i > 0 && { label: i, value: i };
                    }).filter((e) => e)}
                  />
                </Form.Item>
              ) : null}
              {/* no of matches */}
              <Form
                style={{ display: "flex", gap: "8%", marginTop: "30px" }}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                autoComplete="off">
                <Form.Item className="halfwidth profileItems">
                  <label className="boldlabel">No of Matches</label>
                  <Select
                    value={noofMatches}
                    placeholder="1,2,3,4,..."
                    style={{ minWidth: "200px" }}
                    allowClear
                    onChange={(e) => setnoofMatches(e)}
                    onClear={() => {
                      setnoofMatches(1);
                    }}
                    options={Array.from({ length: 7 }, (_, i) => {
                      const condition = i > 0;
                      return condition ? { label: i, value: i } : null;
                    }).filter((e) => e)}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        )}
        {/* step 1: two match timings*/}

        {currentStep === 1 && (
          <Row justify="space-between">
            <Col>
              {/* start time */}
              <Form
                style={{ display: "flex", gap: "8%" }}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                autoComplete="off">
                <Form.Item
                  help={
                    valstartingtime === "error"
                      ? `playing hours from starting time should not exceed 24 hours`
                      : ""
                  }
                  hasFeedback
                  validateStatus={valstartingtime}
                  className="profileItems">
                  <label className="boldlabel">Starting Time of First Match</label>
                  <Space>
                    <DatePicker
                      value={
                        !isScrimMode()
                          ? dob?.[0]
                            ? moment(dob?.[0])
                            : ""
                          : moment(state?.startDate)
                      }
                      showSecond={false}
                      disabled={isScrimMode()}
                      disabledDate={(current) => {
                        return (
                          current < moment(state?.startDate).startOf("day") ||
                          current < moment().startOf("day")
                        );
                      }}
                      format="YYYY-MM-DD"
                      onChange={(e, o) => {
                        if (dob?.[1]) {
                          setdob([o, dob?.[1]]);
                        } else {
                          setdob([o, ""]);
                        }
                      }}
                    />
                    <TimePicker
                      value={
                        !isScrimMode()
                          ? dob?.[1]
                            ? moment(dob[1], "HH:mm")
                            : ""
                          : moment(state?.startTime, "HH:mm")
                      }
                      renderExtraFooter={() => "Hour :  Min"}
                      format={"HH:mm"}
                      disabled={!dob?.[0]}
                      inputReadOnly
                      disabledTime={() => {
                        // Only apply restrictions if selected date is today
                        if (moment(dob?.[0]).isSame(moment(), "day")) {
                          const currentHour = moment().hour();
                          const currentMinute = moment().minute();

                          return {
                            disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
                            disabledMinutes: (selectedHour) =>
                              selectedHour === currentHour
                                ? Array.from({ length: currentMinute + 1 }, (_, i) => i)
                                : []
                          };
                        }
                        return {};
                      }}
                      onChange={(e, i) => {
                        let a = String(i).split(":");
                        if (a[0] === "00" && a[1] === "00") {
                          Info("Time can't be 00:00");
                        } else {
                          // Check if selected time is valid
                          if (
                            moment(dob?.[0]).isSame(moment(), "day") &&
                            moment(i, "HH:mm").isBefore(moment())
                          ) {
                            Info("Cannot select a past time");
                            return;
                          }
                          setdob([dob?.[0], i]);
                        }
                      }}
                    />
                  </Space>
                </Form.Item>
              </Form>
              {/* play hours each day */}
              <br />{" "}
              {!isScrimMode() && (
                <>
                  <label className="boldlabel" style={{ fontSize: "17px" }}>
                    Number of play hours each day
                  </label>
                  <Form
                    style={{
                      display: "flex",
                      gap: "8%",
                      marginTop: "35px",
                      position: "relative"
                    }}
                    name="basic"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    autoComplete="off">
                    <Form.Item
                      style={{ position: "absolute", width: "100%", bottom: "0px" }}
                      help={valtime === "error" ? message : null}
                      hasFeedback
                      required
                      validateStatus={valtime}
                    />
                    <Form.Item className="profileItems">
                      <label className="boldlabel">Hours</label>
                      <Select
                        className="ceinputfieldnos selectSmaller"
                        title="Hours"
                        bordered={true}
                        onSelect={onSelect}
                        value={playingTime?.hours}>
                        {Array(24)
                          .fill(null)
                          .map((_, i) => (
                            <Option
                              value={i < 10 ? "0" + (i + 1) : `${i + 1}`}
                              key={`playingHours${i + 1}`}>
                              {i + 1}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item className="profileItems">
                      <label className="boldlabel">Minutes</label>
                      <Select
                        className="ceinputfieldnos selectSmaller"
                        title="Minutes"
                        bordered={true}
                        onSelect={onSelect}
                        value={playingTime?.minutes}>
                        {Array(60)
                          .fill(null)
                          .map((_, i) => (
                            <Option value={i < 10 ? "0" + i : i} key={`playingMinutes${i}`}>
                              {i}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Form>
                </>
              )}
              {/* parallel */}
              {!isScrimMode() && (
                <Form
                  style={{ gap: "5%" }}
                  name="basic"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  initialValues={{ remember: true }}
                  autoComplete="off">
                  <label className="boldlabel" style={{ fontSize: "17px" }}>
                    {/* parralel Matches */}
                    Do you want parallel matches?
                    <Switch
                      style={{ marginLeft: "5px" }}
                      checked={wantParrallelMatches}
                      onChange={() => setwantParrallelMatches((e) => !e)}
                    />
                  </label>
                  <Form.Item
                    style={{ display: wantParrallelMatches ? "block" : "none" }}
                    className="profileItems halfwidth">
                    <Select
                      className="ceinputfieldnos"
                      title="parralelMatches"
                      style={{ minWidth: "200px", maxWidth: "200px" }}
                      bordered={true}
                      value={parralelMatches}
                      defaultValue={2}
                      onSelect={onSelect}>
                      {Array(10)
                        .fill(null)
                        .map((_, i) => (
                          <Option value={i + 1} key={`parralelMatches${i}`}>
                            {i + 1}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Form>
              )}{" "}
            </Col>
            <Col>
              <Form.Item
                help={!isScrimMode && valbtime === "error" ? message : null}
                hasFeedback
                required
                validateStatus={isScrimMode ? "" : valbtime}
                className="halfwidth profileItems">
                <label className="boldlabel">Time Required for one Match</label>
                <TimePicker
                  renderExtraFooter={() => "Hour :  Min"}
                  format={"HH:mm"}
                  showNow={false}
                  inputReadOnly
                  value={timeforonematch ? moment(timeforonematch, "HH:mm") : undefined}
                  className="mt8"
                  onChange={(e, i) => {
                    let a = String(i).split(":");
                    if (a[0] === "00" && a[1] === "00") {
                      Info("Time can't be 00:00");
                      setTimeforonematch(null);
                    } else setTimeforonematch(i);
                  }}
                />
              </Form.Item>
              <br />
              <label className="boldlabel" style={{ fontSize: "17px" }}>
                Break between each match
              </label>
              <Form
                style={{
                  display: "flex",
                  gap: "8%",
                  marginTop: "30px",
                  position: "relative"
                }}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                autoComplete="off">
                <Form.Item
                  style={{ position: "absolute", width: "100%", bottom: "0px" }}
                  help={valbtime === "error" ? messageb : null}
                  hasFeedback
                  required
                  validateStatus={valbtime}
                />
                <Form.Item className="profileItems">
                  <label className="boldlabel">Hours</label>
                  <Select
                    className="ceinputfieldnos selectSmaller"
                    title="Hours"
                    bordered={true}
                    onSelect={onSelect}
                    value={breakTime?.hours}>
                    {Array(25)
                      .fill(null)
                      .map((_, i) => (
                        <Option value={i} key={`breakHours${i}`}>
                          {i}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                <Form.Item className="profileItems">
                  <label className="boldlabel">Minutes</label>
                  <Select
                    className="ceinputfieldnos selectSmaller"
                    title="Minutes"
                    bordered={true}
                    onSelect={onSelect}
                    value={breakTime?.minutes}>
                    {Array(60)
                      .fill(null)
                      .map((_, i) => (
                        <Option value={i} key={`breakMinutes${i}`}>
                          {i}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        )}

        {currentStep === 2 && (
          <>
            <div style={{ marginBottom: "10px" }}>
              <Switch
                checked={addManually}
                onChange={() => setAddManually((prev) => !prev)}
                checkedChildren="Manual"
                unCheckedChildren="Auto"
              />
            </div>
            <Form
              style={{
                display: "flex",
                gap: "8%",
                marginTop: "0px",
                position: "relative"
              }}
              name="basic"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              autoComplete="off">
              <Form.Item
                style={{ position: "absolute", width: "100%", margin: "0px" }}
                hasFeedback
                required
              />
              <Form.Item className="profileItems">
                <label className="boldlabel" style={{ whiteSpace: "nowrap" }}>
                  kill points
                </label>
                <Select
                  className="ceinputfieldnos selectSmaller"
                  bordered={true}
                  onSelect={(e) => setkillpoints(e)}
                  value={killpoints}>
                  {Array(50)
                    .fill(null)
                    .map((_, i) => (
                      <Option value={i + 1} key={`killpoints${i + 1}`}>
                        {i + 1}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              {addManually && (
                <div
                  style={{
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "1rem"
                  }}>
                  <div style={{ maxWidth: 400 }}>
                    <Row
                      justify="space-between"
                      align="middle"
                      style={{ fontWeight: "bold", marginBottom: 10 }}>
                      <Col md={8} sm={9} xs={7} style={{ textAlign: "left" }}>
                        Ranks
                      </Col>
                      <Col md={4} sm={4} xs={3} style={{ textAlign: "center" }}>
                        Points
                      </Col>
                    </Row>

                    {individualRankPoints.map(({ rank, points }) => (
                      <Row
                        key={rank}
                        justify="space-between"
                        align="middle"
                        style={{ marginBottom: 0 }}>
                        <Col md={8} sm={9} xs={7}>
                          <span>Rank: {rank}</span>
                        </Col>

                        <Col md={4} sm={4} xs={3} style={{ textAlign: "center" }}>
                          <Form.Item style={{ marginBottom: "5px" }}>
                            <InputNumber
                              min={0}
                              value={points}
                              onChange={(value) => handlePointsChange(value, rank)}
                              className="killsinput"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>
              )}
              {!addManually && (
                <>
                  <Form.Item className="profileItems">
                    <label className="boldlabel">Points for 1st rank</label>
                    <Select
                      className="ceinputfieldnos selectSmaller"
                      bordered={true}
                      onSelect={(e) => setistrankpoints(e)}
                      value={istrankpoints}>
                      {Array(51)
                        .fill(null)
                        .map((_, i) => (
                          <Option value={i} key={`1strankpoints${i}`}>
                            {i}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item className="profileItems">
                    <label className="boldlabel">Points for Last rank</label>
                    <Select
                      className="ceinputfieldnos selectSmaller"
                      bordered={true}
                      onSelect={(e) => setlastrankpoints(e)}
                      value={lastrankpoints}>
                      {Array(51)
                        .fill(null)
                        .map((_, i) => (
                          <Option value={i} key={`lastrankpoints${i}`}>
                            {i}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </>
              )}
            </Form>
          </>
        )}
      </main>

      <Row justify="center">
        {currentStep !== 0 && (
          <Button
            type="primary"
            onClick={() => handleChangeStep("prev")}
            className="mr-5"
            disabled={currentStep === 0}>
            Previous
          </Button>
        )}
        {currentStep !== 2 && (
          <Button
            type="primary"
            onClick={() => handleChangeStep("next")}
            disabled={currentStep === 2}>
            Next
          </Button>
        )}
      </Row>
    </>
  );
}

export default MultiPlayerScheduleFields;
